import React from 'react'
import ReactMenu from 'srcReact/components/common2/ReactMenu'
import IconButton from 'srcReact/components/common2/IconButton'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'

function Actions({ id, scope, handlePreviewMixrOrDraft, handleUseMixrOrDraft, handleDeleteDraft }) {
  const { t } = useTranslation()
  const getOptions = () => {
    let actions = []
    actions.push({
      text: scope === 'draft' ? t('event.create.startFrom.useDraft') : t('event.create.startFrom.useMixr'),
      onClick: () => handleUseMixrOrDraft(id)
    })

    actions.push({
      text: scope === 'draft' ? t('event.create.startFrom.previewDraft') : t('event.create.startFrom.previewMixr'),
      onClick: () => handlePreviewMixrOrDraft(id)
    })
    {
      scope === 'draft' &&
        actions.push({
          text: t('event.create.startFrom.deleteDraft'),
          onClick: () => handleDeleteDraft(id)
        })
    }

    return actions
  }
  return (
    <div className={styles.action}>
      <IconButton
        className={styles.iconActionButton}
        iconName='see'
        size='large24'
        onClick={() => handlePreviewMixrOrDraft(id)}
      />
      <ReactMenu
        options={getOptions()}
        direction='right'
        menuCSS={styles.menuOptions}
        menuButtonCSS={styles.btnOptions}
      />
    </div>
  )
}

export default Actions
